import React, {Fragment, useEffect, useState} from "react";
import "./EV.css";
import Header from "./Header";
import Footer from "./Footer";
import Consulta from "./Consulta";
import axios from "axios";
import {Container, Row, Col} from "react-bootstrap";
import {Election} from "./Election";
import {ObjectMap} from "./ObjectMap";
import {objectToMap} from "./util";


const Home = (props: any) => {
    const [loading, setLoading] = useState<boolean>(true);
    const [election, setElection] = useState<Election | null>(null);
    const [messages, setMessages] = useState<ObjectMap<string> | null>(null);

    useEffect(() => {
        const election_id = props.match.params.election_id;

        (async () => {
            try {
                const election: Election = (await axios({
                    method: "get",
                    url: process.env.REACT_APP_API_URL + "/election/" + election_id
                })).data;

                if (election.configuration.templates.filter(t => t.name === "ask_messages.json").length > 0) {
                    const json_messages = await axios({
                        method: "get",
                        url: election.configuration.templates.filter(t => t.name === "ask_messages.json")[0].content
                    });
                    const messages: ObjectMap<string> = objectToMap<string>(json_messages.data);

                    setMessages(messages);
                }
                setElection(election);
                setLoading(false);

            } catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }
        })()
    }, [props.match.params.election_id]);

    return (
        election != null ? (
            <Container fluid>
                <Header election={election}/>

                <Consulta election={election} messages={messages}/>


                <Footer messages={messages}/>
            </Container>
        ) : (
            <Container fluid>
                <Row className={"mt-4"}>
                    <Col className={"text-center"}>
                        {loading ? (
                            <div className={"spinner"}/>
                        ) : (
                            <p>No fue posible cargar la elección</p>
                        )}
                    </Col>

                </Row>
                <Footer messages={messages}/>
            </Container>
        )
    )
        ;
}


export default Home;
